import { useMemo } from 'react';
import { useUserCan, useUserCanAny } from '../../../hooks/useUserCan';
import { useRqChildCompanies } from '../../../react_query/messages/sharing';

export const useDistrictMessageSharingAccess = (companyId: number) => {
  const isAdmin = useUserCanAny('is-admin');
  const canViewHierarchy = useUserCan('district-hierarchy:view');
  const canUpdateSharing = useUserCan('district-message-sharing:update');
  const hasSharingPermission = isAdmin || (canViewHierarchy && canUpdateSharing);

  const {data: childCompanies, isLoading} = useRqChildCompanies(
    companyId,
    hasSharingPermission && Boolean(companyId),
  );

  const hasActiveChildCompanies = useMemo(() => {
    return (childCompanies || []).some(company => company.is_active);
  }, [childCompanies]);

  return {
    canManageDistrictSharing:
      hasSharingPermission && hasActiveChildCompanies,
    hasSharingPermission,
    hasActiveChildCompanies,
    isLoadingChildCompanies: isLoading,
  };
};